import { render, staticRenderFns } from "./ModelViewVk.vue?vue&type=template&id=2162a83e&scoped=true"
import script from "./ModelViewVk.vue?vue&type=script&lang=js"
export * from "./ModelViewVk.vue?vue&type=script&lang=js"
import style0 from "./ModelViewVk.vue?vue&type=style&index=0&id=2162a83e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2162a83e",
  null
  
)

export default component.exports